export const SearchIndexes = {
    Articles: 'blogpost',
    Products: 'product',
    Professionals: 'professional',
    Projects: 'project',
} as const;

export type SearchIndexes = (typeof SearchIndexes)[keyof typeof SearchIndexes];
